export default __webpack_public_path__ + "static/media/RH.9898f0be.svg";